export const getRowSelectionsForKeyPress = (currentIndex, keypress, dataIds, selectedRows, shiftKey) => {
  let startIndex;
  const startSelectedIndex = dataIds.indexOf(selectedRows[0].id);
  const endSelectedIndex = dataIds.indexOf(selectedRows[selectedRows.length - 1].id);
  let endIndex = Math.max(currentIndex, endSelectedIndex);
  const startDiff = Math.abs(currentIndex - startSelectedIndex);
  const endDiff = Math.abs(currentIndex - endSelectedIndex);

  // this is a case when you have made multiple selections but did not hold down
  // the shift key.  so we are grabbing from the perimeter of the previously
  // selected range
  if (!shiftKey) {
    if (keypress === 'up') {
      return dataIds.slice(startSelectedIndex - 1, startSelectedIndex);
    }
    return dataIds.slice(endSelectedIndex + 1, endSelectedIndex + 2);
  }

  if (startDiff < endDiff) {
    if (keypress === 'down') {
      startIndex = Math.max(currentIndex, startSelectedIndex);
      endIndex += 1;
    } else {
      startIndex = Math.min(currentIndex, startSelectedIndex);
    }
  } else if (keypress === 'down') {
    // this is if you started going up then backtracking
    if (currentIndex > startSelectedIndex && endSelectedIndex > currentIndex) {
      startIndex = currentIndex;
    } else {
      startIndex = Math.min(currentIndex, startSelectedIndex);
    }
    endIndex += 1;
  } else {
    startIndex = Math.min(currentIndex, startSelectedIndex);
  }

  // arrowing up from the bottom to a single selection
  if (currentIndex + 1 === startSelectedIndex && keypress === 'up') {
    endIndex += 1;
  }

  const idsToSelect = dataIds.slice(startIndex, endIndex);
  return idsToSelect;
};
